import { Component, OnInit, Input } from '@angular/core';
import { IServiceFactory } from '../../../Services/service-factory';
import { IStudentLessonService } from '../../../Services/student-lesson-service';
import { StudentLesson } from '../../../Elearning-Models';

@Component({
  selector: 'app-choose-lessons',
  templateUrl: './choose-lessons.component.html',
  styleUrls: ['./choose-lessons.component.scss']
})
export class ChooseLessonsComponent implements OnInit {

  studentLessonService: IStudentLessonService;

  lessonName: string;
  lessons: StudentLesson[] = [];
  @Input() lessonID: number;

  constructor(private serviceFactory: IServiceFactory) { }

  ngOnInit(): void {
    this.getLessonsFromService();
  }


  getLessonsFromService(){
    this.studentLessonService = this.serviceFactory.getStudentLessonService();

    this.studentLessonService.lessonsEmitter.subscribe( result => {
      if(result){
        this.onLessonsAvailableUpdate(result);
      }
    });
    this.studentLessonService.emitLessons(this.lessonID);
  }

  onLessonsAvailableUpdate(lessons: StudentLesson[]){
    this.lessonName = lessons[0].AssignmentName;
    this.lessons = lessons;
  }

  goToStudentAssignmentFromClick(assignmentID: number){
    window.location.href="/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=" + assignmentID;
  }
}
